import { wantedHistoryService } from "../_services/wanted_history.service";

export const wantedHistoryAction = {
  createUpdateHistory,
  getWantedHistory,
  getWantedHistoryByAccusedDistrict,
  getWantedHistoryByAccusedCity,
  getWantedHistoryCount,
  getWantedHistoryListCityWise,
};
function createUpdateHistory(values) {
  return wantedHistoryService.createUpdateHistory(values);
}
function getWantedHistory(values) {
  return wantedHistoryService.getWantedHistory(values);
}
function getWantedHistoryByAccusedDistrict(values) {
  return wantedHistoryService.getWantedHistoryByAccusedDistrict(values);
}
function getWantedHistoryByAccusedCity(values) {
  return wantedHistoryService.getWantedHistoryByAccusedCity(values);
}
function getWantedHistoryCount(values) {
  return wantedHistoryService.getWantedHistoryCount(values);
}
function getWantedHistoryListCityWise(values){
  return wantedHistoryService.getWantedHistoryListCityWise(values);
}
